import {InitialTranslationsLoader, initializeTranslations} from '@app/shared/services/initial-translations';
import {routes} from "@app/app-routing";
import * as Sentry from "@sentry/angular";
import en from '@angular/common/locales/en';
import {en_US, NZ_I18N} from "ng-zorro-antd/i18n";
import {NzImageService} from "ng-zorro-antd/image";
import {NzDrawerService} from "ng-zorro-antd/drawer";
import {NzMessageService} from "ng-zorro-antd/message";
import {NZ_CONFIG, NzConfig} from "ng-zorro-antd/core/config";
import {TrailingSlashUrlSerializer} from "@app/shared/helpers";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {NZ_MODAL_DATA, NzModalService} from "ng-zorro-antd/modal";
import {provideTranslateService, TranslateLoader} from "@ngx-translate/core";
import {DatePipe, registerLocaleData} from "@angular/common";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {provideClientHydration, withIncrementalHydration} from "@angular/platform-browser";
import {ApplicationConfig, ErrorHandler, inject, provideAppInitializer} from '@angular/core';
import {
  provideRouter,
  Router,
  UrlSerializer,
  withInMemoryScrolling
} from "@angular/router";
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withJsonpSupport
} from "@angular/common/http";
import {
  cacheInterceptor,
  errorLogInterceptor,
  notifierInterceptor,
  tokenInterceptor,
  urlPrefixInterceptor
} from "@app/shared/interceptors";

registerLocaleData(en);

const ngZorroConfig: NzConfig = {
  message: {
    nzMaxStack: 1
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(initializeTranslations),
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useClass: InitialTranslationsLoader
      }
    }),
    {
      provide: UrlSerializer,
      useClass: TrailingSlashUrlSerializer
    },
    DatePipe,
    NzNotificationService,
    NzMessageService,
    NzImageService,
    NzDrawerService,
    NzModalService,
    {provide: NZ_MODAL_DATA, useValue: null},
    {provide: NZ_I18N, useValue: en_US},
    {provide: NZ_CONFIG, useValue: ngZorroConfig},
    provideAnimationsAsync(),
    provideRouter(
      routes,
      withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
    ),
    provideHttpClient(
      withJsonpSupport(),
      withFetch(),
      withInterceptors([
        urlPrefixInterceptor,
        cacheInterceptor,
        notifierInterceptor,
        errorLogInterceptor,
        tokenInterceptor
      ]),
    ),
    provideClientHydration(
      withIncrementalHydration(),
      // withHttpTransferCacheOptions({
      //   includeRequestsWithAuthHeaders: false,
      // })
    ),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    })
  ]
};
